export const AUTH_TIMEOUT_MS = 30000 as const
export const PENDING_SIGNIN_TIMEOUT_MS = 300000 as const
export const INPUT_DEBOUNCE_MS = 500 as const
export const DISPLAY_TIMER_MS = 5000 as const
